export const PORTALS = [
  {
    name: "Income Tax e-Filing",
    description: "File income tax returns, view Form 26AS / AIS and access e-filing services of the Income Tax Department.",
    url: "https://www.incometax.gov.in/",
  },
  {
    name: "Income Tax Calculator",
    description: "Compute an indicative tax liability using the official calculator provided by the Income Tax Department.",
    url: "https://www.incometax.gov.in/iec/foportal/income-tax-calculator",
  },
  {
    name: "GST Portal",
    description: "GST registration, return filing, payments, refunds and related services of the Goods and Services Tax Network.",
    url: "https://www.gst.gov.in/",
  },
  {
    name: "Udyam Registration",
    description: "Official MSME (Udyam) registration portal of the Ministry of Micro, Small and Medium Enterprises.",
    url: "https://udyamregistration.gov.in/",
  },
  {
    name: "Shop & Establishment – Maharashtra Labour",
    description: "Maharashtra Labour Department portal for Shops and Establishments registration and related labour services.",
    url: "https://lms.mahaonline.gov.in/",
  },
  {
    name: "MahaRERA",
    description: "Maharashtra Real Estate Regulatory Authority portal for project and agent registrations and complaints.",
    url: "https://www.maharera.maharashtra.gov.in/",
  },
  {
    name: "Ministry of Corporate Affairs (MCA)",
    description: "Company and LLP incorporation, annual filings and corporate registry services.",
    url: "https://www.mca.gov.in/",
  },
];

export const TAX_CALCULATOR_DISCLAIMER =
  "Tax calculations are subject to applicable law, rules, notifications and updates. Please verify the result with current provisions or seek professional advice.";
